import React from "react";
import PropTypes from "prop-types";
import {
  TableBody,
  Table,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import fordStylesOverride from "./ReportPreviewStylesOverride";
import lincolnStylesOverride from "./ReportPreviewLincolnStylesOverride";
import fordStyles from "./ReportPreview-Ford.module.scss";
import lincolnStyles from "./ReportPreview-Lincoln.module.scss";
import { withTranslation } from "react-i18next";
import UpperCaseText from "../../../utils/UpperCaseText";
import { IS_FORD_BRAND } from "../../../utils/EmpUtil";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import EMPButton from "../../../shared/components/EMPButton/EMPButton";

let styles = fordStyles;
let isFordBrand = true;
let stylesOverride = fordStylesOverride;

const updateStyles = (props) => {
  isFordBrand = IS_FORD_BRAND(props.user.dealerBrand);
  stylesOverride = isFordBrand ? fordStylesOverride : lincolnStylesOverride;
  document.body.style.backgroundColor = isFordBrand ? "#ffffff" : "#f6f7f7";
  styles = isFordBrand ? fordStyles : lincolnStyles;
};

const getReportRowKey = (item) => {
  if (item.isTotal) {
    return `total-${item.description || "summary"}`;
  }

  return item.description;
};

const PurchaseRequestPreview = (props) => {
  updateStyles(props);

  const dealerName = props.dealerInfo?.[0]?.dealerName
    ? `${props.dealerInfo[0].dealerName} - `
    : "";

  const dealerInfoText = isFordBrand
    ? UpperCaseText(dealerName) +
      UpperCaseText(props.selectionTypes.filterType) +
      props.selectionTypes.dateRange
    : UpperCaseText(dealerName) +
      props.selectionTypes.filterType +
      props.selectionTypes.dateRange;

  const getCellStyle = (item) =>
    item.isTotal ? stylesOverride.cellGreyBackgroundBold : stylesOverride.cell;

  const getDescription = (item) =>
    item.isTotal ? props.selectionTypes.totalType : item.description;

  return (
    <div className={styles.tablePadding}>
      <div className={styles.info}>
        {props.t("fieldReporting.table.pleaseSelectReport")}
      </div>
      <div className={styles.dealerName}>
        {props.t("fieldReporting.table.purchaseRequestDetails", {
          filterString: `${props.selectionTypes.model}, ${props.selectionTypes.modelYear}`,
        })}
      </div>
      <div className={styles.dealerInfo}>{dealerInfoText}</div>
      <div className={styles.info}>
        <span>{props.t("fieldReporting.table.modelGroupingReportInfo")}</span>
        <EMPButton
          testId="downloadReport"
          disabled={!props.renderPreview}
          onClick={() => props.downloadFieldReport()}
          variant="text"
          leftIcon={<CloudDownloadIcon />}
          submitButton
        >
          {props.t("fieldReporting.download")}
        </EMPButton>
      </div>
      <Table className={styles.table}>
        <TableHead>
          <TableRow>
            <TableCell style={stylesOverride.cellWhiteBackground}>
              <div>{props.t("fieldReporting.table.description")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.active")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.canceled")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.total")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellWhiteBackground}>
              <div>{props.t("fieldReporting.table.purchaseReqAttn")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellWhiteBackground}>
              <div>{props.t("fieldReporting.table.purchasesAccepted")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellWhiteBackground}>
              <div>{props.t("fieldReporting.table.purchasesWithTrade")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.downPaymentsAccepted")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.downPaymentsRefunded")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.downPaymentsRejected")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellWhiteBackground}>
              <div>{props.t("fieldReporting.table.vehiclesOnHold")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.holdDepositsAccepted")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.holdDepositsRefunded")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.holdDepositsRejected")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.unconvertedOrders")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>
                {props.t("fieldReporting.table.conversionRatePurchase")}
              </div>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data !== null &&
            props.data.map((item) => {
              const cellStyle = getCellStyle(item);

              return (
                <TableRow key={getReportRowKey(item)}>
                  <TableCell style={cellStyle}>{getDescription(item)}</TableCell>
                  <TableCell style={cellStyle}>{item.active}</TableCell>
                  <TableCell style={cellStyle}>{item.cancelled}</TableCell>
                  <TableCell style={cellStyle}>{item.total}</TableCell>
                  <TableCell style={cellStyle}>
                    {item.purchaseReqAttention}
                  </TableCell>
                  <TableCell style={cellStyle}>
                    {item.purchasesAccepted}
                  </TableCell>
                  <TableCell style={cellStyle}>{item.purchaseWithTrade}</TableCell>
                  <TableCell style={cellStyle}>
                    {item.downPaymentsAccepted}
                  </TableCell>
                  <TableCell style={cellStyle}>
                    {item.downPaymentsRefunded}
                  </TableCell>
                  <TableCell style={cellStyle}>
                    {item.downPaymentsRejected}
                  </TableCell>
                  <TableCell style={cellStyle}>{item.vehiclesOnHold}</TableCell>
                  <TableCell style={cellStyle}>
                    {item.holdDepositsAccepted}
                  </TableCell>
                  <TableCell style={cellStyle}>
                    {item.holdDepositsRefunded}
                  </TableCell>
                  <TableCell style={cellStyle}>
                    {item.holdDepositsRejected}
                  </TableCell>
                  <TableCell style={cellStyle}>
                    {item.unconvertedOrders}
                  </TableCell>
                  <TableCell style={cellStyle}>{item.otpRate}%</TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </div>
  );
};

const reportValuePropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);

PurchaseRequestPreview.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      active: reportValuePropType,
      cancelled: reportValuePropType,
      description: PropTypes.string,
      downPaymentsAccepted: reportValuePropType,
      downPaymentsRefunded: reportValuePropType,
      downPaymentsRejected: reportValuePropType,
      holdDepositsAccepted: reportValuePropType,
      holdDepositsRefunded: reportValuePropType,
      holdDepositsRejected: reportValuePropType,
      isTotal: PropTypes.bool,
      otpRate: reportValuePropType,
      purchaseReqAttention: reportValuePropType,
      purchasesAccepted: reportValuePropType,
      purchaseWithTrade: reportValuePropType,
      total: reportValuePropType,
      unconvertedOrders: reportValuePropType,
      vehiclesOnHold: reportValuePropType,
    })
  ),
  dealerInfo: PropTypes.arrayOf(
    PropTypes.shape({
      dealerName: PropTypes.string,
    })
  ),
  downloadFieldReport: PropTypes.func.isRequired,
  renderPreview: PropTypes.bool,
  selectionTypes: PropTypes.shape({
    dateRange: PropTypes.string,
    filterType: PropTypes.string,
    model: PropTypes.string,
    modelYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    totalType: PropTypes.string,
  }).isRequired,
  t: PropTypes.func.isRequired,
  user: PropTypes.shape({
    dealerBrand: PropTypes.string,
  }).isRequired,
};

PurchaseRequestPreview.defaultProps = {
  data: null,
  dealerInfo: [],
  renderPreview: false,
};

export default withTranslation("emp")(PurchaseRequestPreview);
